import { __rest } from 'tslib';
import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const PeekMenuItem = styled(
// forwardRef: MenuList/Select attach refs to their items for keyboard focus
// management; dropping the ref breaks arrow-key navigation.
React.forwardRef((_a, ref) => {
    var props = __rest(_a, ["selectedBgColor", "hoverBgColor"]);
    return (React.createElement(MenuItem, Object.assign({ ref: ref }, props)));
}))(({ selectedBgColor, hoverBgColor, theme }) => {
    const hoverColor = 
    //@ts-ignore
    (hoverBgColor && ((theme.palette[hoverBgColor] && theme.palette[hoverBgColor].light) || hoverBgColor)) ||
        //@ts-ignore
        theme.palette.common.opacityTeal;
    const selectedColor = (selectedBgColor &&
        //@ts-ignore
        ((theme.palette[selectedBgColor] && theme.palette[selectedBgColor].light) || selectedBgColor)) ||
        //@ts-ignore
        theme.palette.common.opacityTeal2;
    return Object.assign(Object.assign({}, theme.typography.h5), { backgroundColor: theme.palette.secondary.contrastText, ":hover": {
            backgroundColor: hoverColor,
        }, ":focus": {
            backgroundColor: hoverColor,
        }, "&.MuiMenuItem-root": Object.assign(Object.assign({}, theme.typography.body1), { minHeight: 38, justifyContent: "center", color: theme.palette.text.primary, "~ .MuiMenuItem-root": {
                borderTop: `1px solid ${theme.palette.grey[100]}`,
            }, "&.Mui-selected": {
                backgroundColor: selectedColor,
            } }) });
});

export { PeekMenuItem, PeekMenuItem as default };
